import { useEffect, useState } from "react";

export default function useDebounce(value: string, timeout:number, callback: () => Promise<void>): void {
    const [timer, setTimer] = useState<null | NodeJS.Timeout>(null);

    const clearTimer = () => {
        if (timer) clearTimeout(timer);
    };

    useEffect(() => {
        clearTimer();

        if (value && callback) {
            const newTimer = setTimeout(callback, timeout);
            setTimer(newTimer);
        }
    }, [value]);
}

